// Sales regions (Vertriebsgebiete) shown as a multi-select dropdown (SIB-817).
// The value is persisted by the backend as a single string; in the UI we let
// the user pick multiple regions and store them as a comma-joined string, so
// the API contract stays unchanged.

export const SALES_REGION_OPTIONS: { value: string; label: string }[] = [
  { value: 'V1', label: 'V1' },
  { value: 'V2 Nord', label: 'V2 Nord' },
  { value: 'V2 Süd', label: 'V2 Süd' },
  { value: 'V3', label: 'V3' },
  // Central Union Investment (Frankfurt) demands, not tied to a regional territory (SIB-886).
  { value: 'Union Investment', label: 'Union Investment' },
]

export const SALES_REGION_VALUES = SALES_REGION_OPTIONS.map(o => o.value)

/** Split the persisted comma-joined string into the array the select works with. */
export function parseSalesRegions(value?: string | null): string[] {
  if (!value) return []
  return value
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
}

/** Join the selected regions back into the persisted comma-joined string. */
export function joinSalesRegions(values: string[]): string {
  return values.join(', ')
}

/** Human-readable label for a stored value, falling back to the raw value. */
export function salesRegionLabel(value: string): string {
  return SALES_REGION_OPTIONS.find(o => o.value === value)?.label ?? value
}
